import type { DemoScript } from "../types";
import { CALCULATOR_SCRIPT_COPY } from "./calculator-script.copy";

export const buildCalculatorScript = (): DemoScript => [
  {
    id: "calc-intro",
    narrative: CALCULATOR_SCRIPT_COPY.calcIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "calc-toolbar",
    narrative: CALCULATOR_SCRIPT_COPY.calcToolbar.narrative,
    zoomTargetId: "calc-toolbar",
    callout: {
      targetId: "calc-toolbar",
      text: CALCULATOR_SCRIPT_COPY.calcToolbar.callout,
    },
    durationMs: 5200,
  },
  {
    id: "calc-overview",
    narrative: CALCULATOR_SCRIPT_COPY.calcOverview.narrative,
    durationMs: 1800,
  },
  {
    id: "calc-cards",
    narrative: CALCULATOR_SCRIPT_COPY.calcCards.narrative,
    zoomTargetId: "calc-cards",
    callout: {
      targetId: "calc-cards",
      text: CALCULATOR_SCRIPT_COPY.calcCards.callout,
    },
    durationMs: 5400,
  },
  {
    id: "calc-card-value",
    narrative: CALCULATOR_SCRIPT_COPY.calcCardValue.narrative,
    zoomTargetId: "calc-card-primary",
    zoomScale: 1.22,
    callout: {
      targetId: "calc-card-primary",
      text: CALCULATOR_SCRIPT_COPY.calcCardValue.callout,
    },
    durationMs: 5200,
  },
  {
    id: "calc-new",
    narrative: CALCULATOR_SCRIPT_COPY.calcNew.narrative,
    zoomTargetId: "calc-new-btn",
    callout: {
      targetId: "calc-new-btn",
      text: CALCULATOR_SCRIPT_COPY.calcNew.callout,
    },
    durationMs: 4800,
  },
  {
    id: "calc-modal-open",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalOpen.narrative,
    zoomTargetId: "calc-modal",
    zoomScale: 1.15,
    callout: {
      targetId: "calc-modal",
      text: CALCULATOR_SCRIPT_COPY.calcModalOpen.callout,
    },
    durationMs: 5200,
  },
  {
    id: "calc-modal-title",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalTitle.narrative,
    zoomTargetId: "calc-modal-title",
    zoomScale: 1.12,
    callout: {
      targetId: "calc-modal-title",
      text: CALCULATOR_SCRIPT_COPY.calcModalTitle.callout,
    },
    durationMs: 5000,
  },
  {
    id: "calc-modal-profile",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalProfile.narrative,
    zoomTargetId: "calc-modal-profile",
    zoomScale: 1.1,
    callout: {
      targetId: "calc-modal-profile",
      text: CALCULATOR_SCRIPT_COPY.calcModalProfile.callout,
    },
    durationMs: 5200,
  },
  {
    id: "calc-modal-deliverables",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalDeliverables.narrative,
    zoomTargetId: "calc-modal-deliverables",
    zoomScale: 1.08,
    callout: {
      targetId: "calc-modal-deliverables",
      text: CALCULATOR_SCRIPT_COPY.calcModalDeliverables.callout,
    },
    durationMs: 5400,
  },
  {
    id: "calc-modal-extras",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalExtras.narrative,
    zoomTargetId: "calc-modal-extras",
    zoomScale: 1.08,
    callout: {
      targetId: "calc-modal-extras",
      text: CALCULATOR_SCRIPT_COPY.calcModalExtras.callout,
    },
    durationMs: 5200,
  },
  {
    id: "calc-modal-result",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalResult.narrative,
    zoomTargetId: "calc-modal-result",
    zoomScale: 1.1,
    callout: {
      targetId: "calc-modal-result",
      text: CALCULATOR_SCRIPT_COPY.calcModalResult.callout,
    },
    durationMs: 5400,
  },
  {
    id: "calc-modal-save",
    narrative: CALCULATOR_SCRIPT_COPY.calcModalSave.narrative,
    zoomTargetId: "calc-modal-save",
    zoomScale: 1.08,
    callout: {
      targetId: "calc-modal-save",
      text: CALCULATOR_SCRIPT_COPY.calcModalSave.callout,
    },
    durationMs: 5200,
  },
];
